import React, { Component } from 'react';
import DownloadReportPortfolio from './DownloadReportPortfolio';
import DownloadHourlyPortfolio from './DownloadHourlyPortfolio';
import DownloadHalfHourlyPortfolio from './DownloadHalfHourlyPortfolio';

class DownloadReport extends Component {

  render() {
    const { reportType } = this.props;
    let reportView = <DownloadReportPortfolio />;

    if (reportType === 'hourly') {
      reportView = <DownloadHourlyPortfolio />;
    } else if (reportType === 'half-hourly') {
      reportView = <DownloadHalfHourlyPortfolio />;
    }

    return (
      <div >
        {reportView}
      </div>
    );
  }
}

export default DownloadReport;
